import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';

function shouldShowRemoveButton(
    activeStation,
    FSFLightBoxVisible,
    detailModeStation,
) {
    if (activeStation) {
        if (FSFLightBoxVisible) {
            if (detailModeStation === activeStation.id) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return false;
    }
}

function WheelAlignmentInfoLightBoxContent(props) {
    const {
        expanded,
        FSFLightBoxVisible,
        activeStation,
        detailModeStation,
        onExpand,
        onRemove,
        onAccept,
        onClose
    } = props;

    const showRemoveButton = shouldShowRemoveButton(
        activeStation,
        FSFLightBoxVisible,
        detailModeStation
    );

    return (
        <div className="wheel-alignment-info-light-box__content wheel-alignment-info-light-box-content">
            <p className="wheel-alignment-info-light-box-content__why-alignment">
                <Translation
                    tagName="b"
                    translationKey="wheel-alignment-info-light-box-why-alignment-prefix"
                />
                {' '}
                <Translation translationKey="wheel-alignment-info-light-box-why-alignment" />
                {' '}
                {!expanded &&
                    <Translation
                        className="wheel-alignment-info-light-box-content__learn-more-link"
                        onClick={onExpand}
                        translationKey="wheel-alignment-info-light-box-how-it-works-more-link"
                    />
                }
            </p>

            {expanded &&
                <p className="wheel-alignment-info-light-box-content__how-it-works">
                    <Translation
                        tagName="strong"
                        className="wheel-alignment-info-light-box-content__how-it-works-headline"
                        translationKey="wheel-alignment-info-light-box-how-it-works-headline"
                    />
                    <Translation
                        translationKey="wheel-alignment-info-light-box-how-it-works-content"
                    />
                </p>
            }

            {expanded &&
                <p className="wheel-alignment-info-light-box-content__out-of-alignment-conditions">
                    <Translation
                        tagName="strong"
                        className="wheel-alignment-info-light-box-content__out-of-alignment-conditions-headline"
                        translationKey="wheel-alignment-info-light-box-out-of-alignment-conditions-headline"
                    />
                    <Translation
                        translationKey="wheel-alignment-info-light-box-out-of-alignment-conditions-content"
                    />
                </p>
            }

            <div className="wheel-alignment-info-light-box-content__actions">
                <Translation
                    tagName="button"
                    className="wheel-alignment-info-light-box-content__action-accept"
                    onClick={onAccept}
                    translationKey="wheel-alignment-info-light-box-header-action-accept"
                />

                {showRemoveButton &&
                    <Translation
                        tagName="button"
                        className="wheel-alignment-info-light-box-content__action-remove"
                        onClick={() => { onRemove(); onClose(); }}
                        translationKey="wheel-alignment-info-light-box-header-action-remove"
                    />
                }
            </div>
        </div>
    );
}

WheelAlignmentInfoLightBoxContent.propTypes = {
    expanded: PropTypes.bool.isRequired,
    FSFLightBoxVisible: PropTypes.bool.isRequired,
    detailModeStation: PropTypes.string,
    activeStation: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { WheelAlignmentInfoLightBoxContent };
